import UpdatesTableActionButton from "./UpdatesTableActionButton/UpdatesTableActionButton";
import UpdatesTableDropdown from "./UpdatesTableDropdown/UpdatesTableDropdown";

const UpdatesTableAction = ({
    editText,
    handleModalAction,
    cannedResourceType,
    hideView,
    updateResource,
    ...rest
}) => {
    return (
        <div className='discovery--actions'>
            <UpdatesTableActionButton
                editText={editText}
                onClick={handleModalAction}
                updateResource={updateResource}
            />
            <UpdatesTableDropdown
                hideView={hideView}
                handleModalAction={handleModalAction}
                cannedResourceType={cannedResourceType}
                updateResource={updateResource}
                {...rest}
            />
        </div>
    );
};
export default UpdatesTableAction;
